import { NgModule } from '@angular/core'
import { provideConfig } from '@spartacus/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import { TRAINING_FACET_CONVERTER } from './index'
import { TrainingFacetConverter } from './training-facet.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        trainingFacetFeature: {
          module: () => import('./training-facet.module').then((m) => m.TrainingFacetModule),
          cmsComponents: ['training_facet'],
        },
      }
    }),
    {
      provide: TRAINING_FACET_CONVERTER,
      useExisting: TrainingFacetConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        training_facet: TRAINING_FACET_CONVERTER
      },
      multi: true
    }
  ]
})
export class TrainingFacetFeatureModule {
}
